<template>
    <section class="c-case-studies-list">
        <div class="c-case-studies-list__wrapper">
            <div class="c-case-studies-list__categories">
                <ul class="c-case-studies-list__category-list">
                    <li
                        v-for="category in categories"
                        :key="category.id"
                        class="c-case-studies-list__category-item"
                        :class="{'active-item' : $route.query.category === category.url_encode}"
                        @click="filterCategories(category.url_encode)"
                    >
                        {{ category.title }}
                    </li>
                </ul>
            </div>
            <ul class="c-case-studies-list__category-list-responsive">
                <li
                    v-for="category in categories"
                    :key="category.id"
                    class="c-case-studies-list__category-item-responsive"
                    :class="{'active-item-responsive' : $route.query.category === category.url_encode}"
                    @click="filterCategories(category.url_encode)"
                >
                    {{ category.title }}
                </li>
            </ul>
            <div class="c-case-studies-list__cases-wrapper">
                <div
                    ref="projects"
                    class="c-case-studies-list__cases"
                >
                    <router-link
                        v-for="caseStudy in integrateArray"
                        :key="caseStudy.id"
                        :to="{
                            name: 'case-study-single',
                            params: {slug: caseStudy.slug}
                        }"
                        class="c-case-studies-list__case-box"
                    >
                        <img
                            :src="imgSrc(caseStudy.image,'main1')"
                            :alt="caseStudy.title"
                        >
                        <h5>
                            {{ caseStudy.title }}
                        </h5>
                        <p>
                            {{ caseStudy.synopsis }}
                        </p>
                    </router-link>
                </div>

                <div class="c-case-studies-list__action">
                    <y-button
                        v-if="chunkNumber < chunk.length - 1"
                        color="white p-4"
                        class="button"
                        flat
                        @click="Pagination"
                    >
                        {{ $t('buttons.load_more') }}
                    </y-button>
                </div>
            </div>
        </div>
    </section>
</template>

<script >

    export default {
        name : 'CaseStudiesList',
        /**
         *
         * @inheritDoc
         */
        props: {
            cases: {
                type    : Array,
                required: true,
            },
            categories: {
                type    : Array,
                required: true,
            },
        },

        /**
         * @inheritDoc
         */
        data() {
            return {
                caseStudies   : null,
                routeCategory : '',
                chunk         : [],
                integrateArray: [],
                chunkNumber   : 0,
                order         : 0,
            };
        },

        watch: {
            /**
             * change routes
             */
            $route() {
                if (this.routeCategory === this.$route.query.category) {
                    return;
                }
                if (this.$route.query.category) {
                    this.routeCategory = this.$route.query.category;
                } else {
                    this.routeCategory = 'all_categories';
                }
                this.filterCaseStudies(this.routeCategory);
            },
        },

        /**
         * @inheritdoc
         */
        created() {
            if (this.$route.query.category) {
                this.routeCategory = this.$route.query.category;
            } else {
                this.routeCategory = 'all_categories';
            }
            this.filterCaseStudies(this.routeCategory);
            this.chunkNumber = 0;
            this.integrateArray = this.chunk[this.chunkNumber];
        },

        methods: {
            /**
             * index of sidebar option
             *
             * @param {number} index
             */
            setOrder(index) {
                this.order = index;
            },
            /**
             * Change the url for filtering categories
             *
             * @param {string} url
             */
            filterCategories(url) {
                if (url === this.$route.query.category) {
                    return;
                }
                this.$router.replace({ name: 'case-study', query: { category: url }, hash: '#case-studies' });
            },

            /**
             * Add pagination
             */
            Pagination() {
                this.chunkNumber += 1;
                this.integrateArray = this.integrateArray.concat(this.chunk[this.chunkNumber]);
            },

            /**
             * @inheritdoc
             */
            splitIntoChunk(arr, chunk) {
                for (let i = 0; i < arr.length; i += chunk) {
                    let tempArray = [];
                    tempArray = arr.slice(i, i + chunk);
                    this.chunk.push(tempArray);
                }
            },

            /**
             * filter case studies
             *
             * @param {string} url
             */
            filterCaseStudies(url) {
                this.chunkNumber = 0;

                this.chunk = [];
                const caseHolder = this.cases;
                let newArray = [];
                const arrayIndex = [];
                if (url === 'all_categories') {
                    this.caseStudies = caseHolder;
                    this.splitIntoChunk(this.caseStudies, 6);
                } else {
                    newArray = caseHolder.map((element) => element.tagging_cats.filter((tag) => tag.url_encode === url) );

                    newArray.forEach((currentElement, index) => {
                        if (currentElement.length) {
                            arrayIndex.push(index);
                        }
                    });

                    const result = arrayIndex.map((idx) => caseHolder[idx]);
                    this.caseStudies = result;
                    this.splitIntoChunk(this.caseStudies, 6);
                }
                this.integrateArray = this.chunk[this.chunkNumber];
            },
        },
    };

</script>

<style lang="scss" src="./cases.scss"/>
